import classNames from "classnames/bind";
import styles from "./index.module.scss";
import { Card, Form, Input, Button, notification, Typography, Checkbox, Divider } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import userEventApi from "api/userEvent";
import React, { useEffect, useMemo, useState } from "react";
import eventApi from "api/event";
import moment from "moment";
import { getLocale } from "utils/index";
import { QRCodeCanvas } from "qrcode.react";
import logo from "assets/images/logo.png";

const cx = classNames.bind(styles);
const { Title, Paragraph, Text } = Typography;

export default function FillInfo() {
	const navigate = useNavigate();
	const [api, contextHolder] = notification.useNotification();
	const [form] = Form.useForm();

	const { t } = useTranslation()
	const [info, setInfo] = useState(null);
	const [read, setRead] = useState(false);
	const [event, setEvent] = useState(null);

	const content = useMemo(() => {
		return event?.content?.find(item => item.lang === getLocale())?.value
	}, [event])

	// Generate QR code URL for confirmation
	const qrCodeUrl = useMemo(() => {
		if (!info?._id) return '';
		const domain = window.location.origin;
		return `${domain}/confirm-success?id=${info._id}`;
	}, [info?._id]);

	const openNotificationWithIcon = (type, message, description) => {
		api[type]({ message, description });
	};

	const onChangeRead = (e) => {
		setRead(e.target.checked);
	}

	const getEvent = async () => {
		try {
			const res = await eventApi.get();
			setEvent(res.event)
		} catch (error) {
			console.log(error)
		}
	}

	const onFinish = async (values) => {
		try {
			const res = await userEventApi.checkInfo({
				code: +values.code,
			});
			setInfo(res.userEvent)
			openNotificationWithIcon('success', t('notification'), t('success'))
		} catch (error) {
			openNotificationWithIcon('error', t('error'), error?.response?.data?.message)
		}
	};

	const onFinishConfirm = async (isJoined) => {
		try {
			await userEventApi.update(info._id, { isJoined });
			openNotificationWithIcon('success', t('notification'), t('success'))
			setInfo(null)
			setRead(false)
			form.resetFields();
		} catch (error) {
			openNotificationWithIcon('error', t('error'), error?.response?.data?.message)
		}
	}

	useEffect(() => {
		getEvent();
	}, []);

	return (
		<div className={cx("page-login")}>
			{contextHolder}
			<Card className={cx("login-card", info ? 'mt-100' : '')} style={{ width: 500 }}>
				{
					info ?
						<>
							<p className={cx("title")}>{t('condition')}</p>

							{/* User Info Display */}
							<div className={cx("user-info")}>
								<h3 className={cx("user-name")}>
									{info.firstName} {info.lastName}
								</h3>

								{/* QR Code Display */}
								<div className={cx("qr-container")}>
									<QRCodeCanvas
										value={qrCodeUrl}
										size={200}
										level="M"
										includeMargin={true}
									/>
								</div>
							</div>

							<Typography>
								<Paragraph style={{ whiteSpace: 'pre-wrap' }}>
									{content}
								</Paragraph>
								<Text mark>{t('expiredAt')}: {moment(event?.expiredAt).format('DD-MM-YYYY')}</Text>
							</Typography>
							<Checkbox disabled={moment(event?.expiredAt).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')} value={read} onChange={onChangeRead}>{t('readAndAgree')}</Checkbox>
							<Divider />
							<div className={cx("btns")}>
								<Button disabled={!read} style={{ width: '200px' }} type="primary" size="large" onClick={() => onFinishConfirm(true)}>
									{t('join')}
								</Button>
								<Button disabled={!read} style={{ width: '200px' }} size="large" onClick={() => onFinishConfirm(false)}>
									{t('notJoin')}
								</Button>
							</div>
						</> :
						<>
							<div className={cx("logo-container")}>
								<img src={logo} alt="Logo" className={cx("logo")} />
							</div>
							<p className={cx("title")}>{t('employeeInfo')}</p>
							<Form form={form} onFinish={onFinish}>
								<Form.Item
									name="code"
									rules={[
										{
											required: true,
										},
									]}
								>
									<Input
										placeholder={t('code')}
										size="large"
									/>
								</Form.Item>
								<Button type="primary" htmlType="submit" className={cx("login-form-button")} size="large">
									{t('confirm')}
								</Button>
								<Link to='/login'>
									{t('moveToManager')}
								</Link>
							</Form>
						</>
				}
			</Card>
		</div>
	);
}
